module.exports = __webpack_public_path__ + "img/filter-sensor-vent.f2c7ef46.jpg";